const LANGUAGES = {
	PL: {
		name: 'Polski',
		flag: 'pl',
	},
	EN: {
		name: 'English',
		flag: 'gb',
	},
} as const;

export default LANGUAGES;
